import styled from 'styled-components';
import { LoginButton } from '../Styled/Buttons';

export const CardInputBox = styled.div`
    margin: 10px;
    text-align: right;
    &:hover{
    cursor: pointer;
    }
`;

export const CardImg = styled.div`
    display: flex;
    align-items: center;
    height: 35px;`;

export const CardInput = styled.input`
    font-family: inherit;
    margin-left: 10px;
    height: 25px;
    width: 100%;
    padding: .45rem .9rem;
    font-size: .9rem;
    font-weight: 400;
    line-height: 1.5;
    color: #6c757d;
    background-clip: padding-box;
    border: 1px solid #dee2e6;
    background-color: #e8f0fe;
    appearance: none;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
`;

export const CardInputLabel = styled.label`
    font-family: "Nunito",sans-serif;
    font-size: .7rem;
    line-height: 1.5;
    color: #6c757d;
    display: inline-block;
    font-weight: 400;
    margin-bottom: 5px;
    text-align: right;
    &:hover{
        cursor: pointer;
    }
`;
export const CardInputLabelCenter = styled(CardInputLabel)`
    text-align: center;
`;

export const CardButtonPass = styled.div`
    height: 25px;
    display: flex;
    align-items: center;
    padding: .45rem .9rem;
    border-radius: .25rem;
    color: #6c757d;
    text-align: center;
    background-color: #eef2f7;
    border: 1px solid #dee2e6;
    border-radius: .25rem;
    margin-left: -3px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    &:hover{
        cursor: pointer;
   }

`;

export const Modal = styled.div`
position: absolut;
top: auto;
right: auto;
`;

export const CardButton = styled.button`
    font-family: inherit;
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    text-align: center;
    vertical-align: middle;
    border: 1px solid transparent;
    padding: .45rem .9rem;
    font-size: .9rem;
    border-radius: .15rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    color: #fff;
    background-color: #727cf5;
    border-color: #727cf5;
    box-shadow: 0 2px 6px 0 rgba(114,124,245,.5);
    cursor: pointer;
`;

export const LoginCard = styled.div`
    width: 330px;
    background: #ffff;
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    border-radius: .25rem;
    border: none;
    box-shadow: 0 0 35px 0 rgba(154,161,171,.15);
    margin: auto;
`;

export const CardButtonBox = styled.div`
    margin: 20px auto;
    max-width: 30px;
    display: flex;
    justify-content: center;
`;

export const CloseButton = styled.div`
    position: absolute;
    right: 5px;
    top: 5px;    
`;

export const MyLoginButton = styled(LoginButton)`
  color: white;
  background-color:  ${({ disabled }) => (disabled ? '#c7f8f6' : '#00b5ad')};
  border-radius: .3rem;
  outline: none;
  width: 100%;
  border: none;
  padding: 7px 0;
  font-weight: 700;
`;

export const Container = styled.div`
  background: rgba(0,0,0,.3);
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Form = styled.form`
  background: white;
  border-radius: .3rem;
  padding: 20px 20px;
  width: 20%;
  box-shadow: 0px 1px 30px -4px rgba(58,140,194,1);
  
  @media (max-width: 600px) {
  width: auto;
  }
`;

export const Header = styled.div`
  color: #00b5ad;
  text-align: center;
  font-size: 1.5em;
  font-weight: 700;
  margin-bottom: 10px;
`;

export const StyledInputContainer = styled.div`
  margin-bottom: 10px;
`;

const LoginComponents = {
  CardInputBox,
  CardInputLabel,
  CardButtonPass,
  Modal,
  CardButton,
  LoginCard,
  CardButtonBox,
  CloseButton,
  MyLoginButton,
  Container,
  Form,
  Header,
  StyledInputContainer,
  CardInputLabelCenter,
};

export default LoginComponents;
